<template>
  <div>
    <RouterView />
  </div>
</template>

<script>
export default {
  data () {
    return {
      title: 'Consignments',
      breadcrumb: {
        name: 'Consignments',
        route: { name: 'freight-consignments-v3' }
      }
    }
  }
}
</script>
